import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IFavorite } from '../interfaces/Favorite.js';

/**
 * Favorite
 */
class Favorite extends ABaseModel implements IFavorite {
  id: number;
  visitorId: number;
  artId: number;
  artTitle: string;
  artMedium: string;
  artSubMedium: string;
  artSubject: string;
  artSubSubject: string;
  artStyle: string;
  artIsProduct: boolean;
  artSlug: string;
  artistId: number;
  artistAlias: string;
  artistName: string;
  productId: number;
  productType: string;
  productSkuId: number;
  productSku: string;
  productSkuPrice: number;
  productSkuCurrency: string;
  sellerId: number;
  sellerName: string;
  sellerType: number;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Favorite };
